import { createMocksInterceptor } from '@backbase/foundation-ang/data-http';
import { ProductSummaryDataHttpMocksProvider } from './mocks/productSummaryDataMock';
import { TransactionsDataHttpMocksProvider } from './mocks/transactionsDataMock';
import { CategoriesManagementDataHttpMocksProvider } from './mocks/categoriesDataMock';
import { ArrangementsDataHttpMocksProvider } from './mocks/arrangements-credit-card-multi-sfernandez';
import { AccountStatementHttpServiceGetAccountStatementsMocksProvider } from './mocks/account-statements.mocks';
// import { ContactsHttpServiceGetContactsMocksProvider } from '@backbase/data-ang/contact-manager';
import { ContactsHttpServiceGetContactsMocksProvider } from './mocks/contacts-base-mocks';
// import { CataloguesHttpServiceMocksProvider } from 'banesco-catalogues-api';
import {
  ContactsHttpServiceGetContactByTypeIdMocksProvider,
  // ContactsHttpServiceMocksProvider,
} from 'banesco-contact-aux-api';
import { PaymentOrderAuxHttpMocksProvider } from './mocks/payment-order-aux-service.mocks';

export const mockProviders = [
  createMocksInterceptor(),
  ProductSummaryDataHttpMocksProvider,
  TransactionsDataHttpMocksProvider,
  CategoriesManagementDataHttpMocksProvider,
  ArrangementsDataHttpMocksProvider,
  AccountStatementHttpServiceGetAccountStatementsMocksProvider,
  ContactsHttpServiceGetContactsMocksProvider,
  // CataloguesHttpServiceMocksProvider,
  // ContactsHttpServiceMocksProvider,
  PaymentOrderAuxHttpMocksProvider,
];
